import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy'>
      <h1>Privacy Policy</h1>
      {/* Add your privacy policy content here */}
      <p>Rep Timer
        <br></br>
        <br></br>
            Last updated: 10.12.23
            <br></br>
            <br></br>
            At Rep Timer, accessible from reptimer.com, one of our main priorities is the privacy of our users. This Privacy Policy document outlines the types of information that are collected and recorded by Rep Timer and how we use it.
            <br></br>
            <br></br>
            Log Files
            <br></br>
            <br></br>
            Rep Timer follows a standard procedure of using log files. These files log visitors when they visit websites. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable.
            <br></br>
            <br></br>
            Local Storage
            <br></br>
            <br></br>
            We use local storage to store information about your workout routines and preferences. This data is stored on your device and is not transmitted to our servers or any third parties. It includes, but is not limited to, your workout logs and settings.
            <br></br>
            <br></br>
            Consent
            <br></br>
            <br></br>
            By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.
            <br></br>
            <br></br>
            Children's Information
            <br></br>
            <br></br>
            Another part of our priority is adding protection for children while using the internet. Rep Timer does not knowingly collect any Personal Identifiable Information from children under the age of 13.
            <br></br>
            <br></br>
            Online Privacy Policy Only
            <br></br>
            <br></br>
            This privacy policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Rep Timer. This policy is not applicable to any information collected offline or via channels other than this website.
            <br></br>
            <br></br>
            Consent Management
            <br></br>
            <br></br>
            Users can choose to accept or reject the use of local storage. Rejecting the use of local storage may limit some functionalities of the app.
            <br></br>
            <br></br>
            Contact Us
            <br></br>
            <br></br>
            If you have any questions about our Privacy Policy, please feel free to contact us at <a href='mailto:info@reptimer.com' style={{fontsize: 'inherit'}}>info@reptimer.com</a>
            <br></br>
            <br></br>
        </p>
    </div>
  );
};

export default PrivacyPolicy;

